import gtm from 'eco-design-reliance/gtm';
import { ItfGTM80Entire, ItfGTM80 } from './type';

// https://docs.google.com/spreadsheets/d/11MquSBS3Lo7WJsZg_bbcDfNOefHKrr0P_YgD7qeBGFQ/edit?pli=1&gid=370435365#gid=370435365
// 【No4.用户行为】Sheet
export const handle_GTM_80 = (data: ItfGTM80) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'click_anchor' } as ItfGTM80Entire);
};
